import React, { useState } from 'react';
import { IconX, IconArrowRight, IconPencil } from '@tabler/icons-react';
import { ChecklistItem } from './ChecklistCard';
interface TaskModalProps {
  isOpen: boolean;
  onClose: () => void;
  checklist: {
    title: string;
    items: ChecklistItem[];
  } | null;
  categoryColor?: string;
  onGoToTasks: () => void;
}
export function TaskModal({
  isOpen,
  onClose,
  checklist,
  categoryColor,
  onGoToTasks
}: TaskModalProps) {
  if (!isOpen || !checklist) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-340">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-yeppy-text bg-opacity-20 backdrop-blur-sm transition-opacity" onClick={onClose} data-id="element-341" />

      {/* Modal Card */}
      <div className="relative bg-white rounded-3xl shadow-xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200" data-id="element-342">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-yeppy-text border-opacity-10" data-id="element-343">
          <h3 className="font-rubik font-semibold text-lg text-yeppy-text" data-id="element-344">
            Anteprima Attività
          </h3>
          <div className="flex items-center gap-2" data-id="element-345">
            <button className="w-8 h-8 flex items-center justify-center rounded-full bg-yeppy-bg text-yeppy-text transition-colors" data-id="element-346">
              <IconPencil className="w-4 h-4" stroke={1.5} data-id="element-347" />
            </button>
            <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full bg-yeppy-bg text-yeppy-text transition-colors" data-id="element-348">
              <IconX className="w-5 h-5" stroke={1.5} data-id="element-349" />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-4 max-h-[60vh] overflow-y-auto" data-id="element-350">
          <ChecklistCard title={checklist.title} items={checklist.items} categoryColor={categoryColor} data-id="element-351" />
        </div>

        {/* Footer with two buttons */}
        <div className="p-4 border-t border-yeppy-text border-opacity-10 bg-yeppy-bg bg-opacity-30 flex gap-3" data-id="element-352">
          {/* Continue editing button */}
          <button onClick={onClose} className="flex-1 flex items-center justify-center gap-2 font-poppins font-medium py-3 px-4 rounded-xl transition-all active:scale-[0.98] bg-white border border-yeppy-text border-opacity-15" style={{
          color: '#1D2A36'
        }} data-id="element-353">
            <IconPencil className="w-4 h-4" data-id="element-354" />
            Modifica
          </button>

          {/* Approve and go to tasks button */}
          <button onClick={onGoToTasks} className="w-full flex items-center justify-center gap-2 py-3.5 rounded-xl font-poppins text-sm font-semibold transition-colors bg-yeppy-text text-white active:scale-[0.98]" data-id="element-355">
            Vai alle attività
            <IconArrowRight className="w-4 h-4" stroke={1.5} data-id="element-356" />
          </button>
        </div>
      </div>
    </div>;
}